<div class="scaffold-item" *ngIf="item && settings[item.type]" #itemcontrols>
  <div
    class="scaffold-editor-items"
    [ngClass]="{
      'item-properties-selected': propertiesSelected,
      'show-comments': getCommentCount(info?.name) > 0 || isActive(),
    }"
    (click)="setPropertiesSelection($event, item)">
    <div
      class="comment-button"
      *ngIf="info?.info && instanceDetails?.scaffoldType === 'designer'"
      (click)="setActiveComments($event)"
      [ngClass]="{ 'active-comment': isActive() }"
      [pTooltip]="getCommentCount(info.name) + ' comments'">
      <p-badge
        [value]="getCommentCount(info?.name)"
        severity="primary"
        position="top left"
        *ngIf="getCommentCount(info?.name) > 0"></p-badge>
      <i
        [status]="isActive() ? 'success' : 'info'"
        [class]="getCommentClass('pack') + ' fa-' + getCommentClass('icon')">
      </i>
    </div>
    <div class="scaffold-item-controls">
      <span>{{ settings[item.type].Name }}</span>
      <div class="scaffold-control-buttons">
        <p-button
          severity="info"
          variant="text"
          (onClick)="setButtons(); itemmenu.toggle($event)"
          aria-label="Data item editor menu">
          <i class="fas fa-bars"></i>
        </p-button>
        <p-menu
          #itemmenu
          [model]="item_menu"
          [popup]="true"
          [appendTo]="'body'"
          [position]="'bottom'"></p-menu>
      </div>
    </div>
    <div
      [ngClass]="{
        'scaffold-moving-item': movingItem.selectedItem === item,
        'scaffold-read-hidden': item.read_hidden,
      }">
      <div [ngSwitch]="item.type" class="scaffold-item-content">
        <div *ngSwitchCase="'heading'" class="scaffold-box-content">
          <h1
            *ngIf="item.heading_type == 'h1'"
            [ngClass]="item.classes"
            id="{{ item.id }}"
            class="{{ item.alignment }}"
            contenteditable="true"
            (paste)="onPaste($event)"
            [(contenteditableModel)]="item.text"
            (click)="stopProp($event)"></h1>
          <h2
            *ngIf="item.heading_type == 'h2'"
            [ngClass]="item.classes"
            id="{{ item.id }}"
            class="{{ item.alignment }}"
            contenteditable="true"
            (paste)="onPaste($event)"
            [(contenteditableModel)]="item.text"
            (click)="stopProp($event)"></h2>
          <h3
            *ngIf="item.heading_type == 'h3'"
            [ngClass]="item.classes"
            id="{{ item.id }}"
            class="{{ item.alignment }}"
            contenteditable="true"
            (paste)="onPaste($event)"
            [(contenteditableModel)]="item.text"
            (click)="stopProp($event)"></h3>
          <h4
            *ngIf="item.heading_type == 'h4'"
            [ngClass]="item.classes"
            id="{{ item.id }}"
            class="{{ item.alignment }}"
            contenteditable="true"
            (paste)="onPaste($event)"
            [(contenteditableModel)]="item.text"
            (click)="stopProp($event)"></h4>
          <h5
            *ngIf="item.heading_type == 'h5'"
            [ngClass]="item.classes"
            id="{{ item.id }}"
            class="{{ item.alignment }}"
            contenteditable="true"
            (paste)="onPaste($event)"
            [(contenteditableModel)]="item.text"
            (click)="stopProp($event)"></h5>
          <h6
            *ngIf="item.heading_type == 'h6'"
            [ngClass]="item.classes"
            id="{{ item.id }}"
            class="{{ item.alignment }}"
            contenteditable="true"
            (paste)="onPaste($event)"
            [(contenteditableModel)]="item.text"
            (click)="stopProp($event)"></h6>
        </div>
        <div *ngSwitchCase="'text'">
          <div *ngIf="!item.name" (click)="stopProp($event)">
            <div class="rte-placeholder" *ngIf="!item.text || item.text === ''">
              Add Text Here
            </div>
            <editor
              [attr.id]="'editor-' + elId"
              *ngIf="editor_options"
              apiKey="test"
              [init]="editor_options"
              [(ngModel)]="item.text"
              (onChange)="editorChange()"></editor>
            <div
              class="editor-standin"
              [hidden]="editor.render && render"
              [innerHTML]="item.text | safeHtml"></div>
          </div>
          <div *ngIf="item.name">Placeholder for {{ item.name }}</div>
        </div>
        <div *ngSwitchCase="'labeled_text'">
          <div
            class="flex-list"
            [attr.id]="item.id ? item.id : null"
            [ngClass]="item.classes">
            <p class="list-title">
              <strong>{{ item.label }}</strong>
            </p>
            <p>{{ data ? data[item.name] : 'Placeholder for ' + item.name }}</p>
          </div>
        </div>
        <div *ngSwitchCase="'editor'" class="editor-in-view">
          <div *ngIf="item.view === 'edit' && item">
            <app-editor
              *ngIf="item.name"
              [items]="item[item.name]"
              [undoService]="undoService"
              [data]="{}"
              [parentView]="item"
              [parents]="[{ type: 'view' }]"
              (editorChange)="
                editDirty(data, item.name, item.content)
              "></app-editor>
          </div>
          {{ item.title || 'Scaffold Editor' }}
          <p-tabs value="0">
            <p-tablist>
              <p-tab
                *ngFor="let template of item.templates; let i = index"
                [value]="i"
                >{{ template.title }}</p-tab
              >
            </p-tablist>
            <p-tabpanels>
              <p-tabpanel
                *ngFor="let template of item.templates; let i = index"
                [value]="i">
                <div
                  class="scaffold-add-buttons scaffold-before-buttons"
                  (mouseover)="last_hovered = true"
                  (mouseout)="last_hovered = false"
                  [ngClass]="{ 'button-menu-hovered': last_hovered }">
                  <hr class="line-highlight" />
                  <div class="add-new-menu">
                    <div class="btw-button-holder">
                      <button
                        pButton
                        [rounded]="true"
                        size="small"
                        (click)="openRootDialog($event, template.content)"
                        [pTooltip]="'add_component' | translation"
                        status="primary"
                        aria-label="Add Component"
                        tooltipPosition="above"
                        class="scaffold-list-insert add-new-item"
                        *ngIf="!movingItem.selectedItem">
                        <span><i class="fas fa-plus"></i></span>
                      </button>
                    </div>
                  </div>
                  <div class="btw-button-holder">
                    <button
                      pButton
                      status="info"
                      [pTooltip]="'add_component' | translation"
                      tooltipPosition="above"
                      class="scaffold-list-insert"
                      (click)="moveItem(null, template.content)"
                      *ngIf="movingItem.selectedItem">
                      Insert
                    </button>
                  </div>
                </div>
                <div class="add-placeholder">
                  <div class="color-bar"></div>
                </div>
                <div>
                  <app-items
                    [info]="info"
                    [toCreateItems]="toCreateItems"
                    (deleteItem)="deleteHandler($event, template.content)"
                    (addItem)="addHandler($event, it, template.content)"
                    *ngFor="let it of template.content"
                    [item]="it"
                    [arr]="template.content"
                    [parents]="parents.concat([item])"
                    [undoService]="undoService"
                    (itemChanged)="subChange($event)"></app-items>
                </div>
              </p-tabpanel>
            </p-tabpanels>
          </p-tabs>
        </div>
        <div *ngSwitchCase="'break'">
          <hr />
        </div>
        <div *ngSwitchCase="'navigation'">
          Links:
          <div *ngFor="let link of item.links">
            {{ link.text }} ({{ link.link }})
          </div>
        </div>
        <div *ngSwitchCase="'menu'">
          Menu Items:
          <ul>
            <li *ngFor="let link of item.content">
              {{ link.text }} ({{ link.operation }})
            </li>
          </ul>
        </div>
        <div *ngSwitchCase="'panel'">
          <p-card
            [attr.data-color]="item.panel_type"
            [attr.id]="item.id ? item.id : null"
            [ngClass]="{ 'borderless-panel': item.hide_border }"
            [header]="item.hide_title ? null : item.heading">
            <div class="card-content">
              <div
                class="scaffold-add-buttons scaffold-before-buttons"
                (mouseover)="last_hovered = true"
                (mouseout)="last_hovered = false"
                [ngClass]="{ 'button-menu-hovered': last_hovered }">
                <hr class="line-highlight" />
                <div class="add-new-menu">
                  <div class="btw-button-holder">
                    <button
                      pButton
                      [rounded]="true"
                      size="small"
                      (click)="openRootDialog($event, item.content)"
                      [pTooltip]="'add_component' | translation"
                      status="primary"
                      aria-label="Add Component"
                      class="scaffold-list-insert add-new-item"
                      *ngIf="!movingItem.selectedItem">
                      <span><i class="fas fa-plus"></i></span>
                    </button>
                  </div>
                </div>
                <div class="btw-button-holder">
                  <button
                    pButton
                    status="info"
                    [pTooltip]="'add_component' | translation"
                    class="scaffold-list-insert"
                    (click)="moveItem(null, item.content)"
                    *ngIf="movingItem.selectedItem">
                    Insert
                  </button>
                </div>
              </div>
              <div class="add-placeholder">
                <div class="color-bar"></div>
              </div>
              <app-items
                [info]="info"
                [toCreateItems]="toCreateItems"
                (moveItemUp)="moveUpHandler($event, item.content)"
                (moveItemDown)="moveDownHandler($event, item.content)"
                (deleteItem)="deleteHandler($event, item.content)"
                (addItem)="addHandler($event, it, item.content)"
                *ngFor="let it of item.content"
                [undoService]="undoService"
                [item]="it"
                [arr]="item.content"
                [parents]="parents.concat([item])"
                (itemChanged)="subChange($event)"></app-items>
              <div class="card-footer" *ngIf="item.footer">
                {{ item.footer }}
              </div>
            </div>
            <ng-template pTemplate="footer">
              <div class="card-footer" *ngIf="item.footer">
                {{ item.footer }}
              </div>
            </ng-template>
          </p-card>
        </div>

        <div *ngSwitchCase="'anchor'">
          <a href="{{ toURL(item.value || item.url) }}" target="_blank">
            {{ item.text }}
          </a>
        </div>
        <div *ngSwitchCase="'item_link'">
          <p *ngIf="item.link_text && item.link_text.name">
            Link Text Key: {{ item.link_text.name }}
          </p>
          <p *ngIf="!item.link_text || !item.link_text.name">
            Link Text: {{ item.label }}
          </p>
          <p *ngIf="item.item_type">Link to type: {{ item.item_type.name }}</p>
          <p *ngIf="item.item_id">Link to ID: {{ item.item_id.name }}</p>
        </div>
        <div *ngSwitchCase="'link'">
          <div *ngIf="item.link_type != 'components'">
            Link to item: <span *ngIf="!item.name">{{ item.text }}</span
            ><span *ngIf="!item.name"
              >Display value from "{{ item.name }}"</span
            >
          </div>
          <div *ngIf="item.link_type == 'components'">
            <div
              class="scaffold-add-buttons scaffold-before-buttons"
              (mouseover)="last_hovered = true"
              (mouseout)="last_hovered = false"
              [ngClass]="{ 'button-menu-hovered': last_hovered }">
              <hr class="line-highlight" />
              <div class="add-new-menu">
                <div class="btw-button-holder">
                  <button
                    pButton
                    [rounded]="true"
                    size="small"
                    (click)="openRootDialog($event, item.content)"
                    [pTooltip]="'add_component' | translation"
                    status="primary"
                    aria-label="Add Component"
                    class="scaffold-list-insert add-new-item"
                    *ngIf="!movingItem.selectedItem">
                    <span><i class="fas fa-plus"></i></span>
                  </button>
                </div>
              </div>
              <div class="btw-button-holder">
                <button
                  pButton
                  severity="info"
                  [pTooltip]="'add_component' | translation"
                  class="scaffold-list-insert"
                  (click)="moveItem(null, item.content)"
                  *ngIf="movingItem.selectedItem">
                  Insert
                </button>
              </div>
            </div>

            <div class="add-placeholder">
              <div class="color-bar"></div>
            </div>
            <app-items
              [info]="info"
              [toCreateItems]="toCreateItems"
              (deleteItem)="deleteHandler($event, item.content)"
              (addItem)="addHandler($event, it, item.content)"
              *ngFor="let it of item.content"
              [item]="it"
              [arr]="item.content"
              [undoService]="undoService"
              [parents]="parents.concat([item])"
              (itemChanged)="subChange($event)"></app-items>

            <div class="clearfix"></div>
          </div>
        </div>
        <div *ngSwitchCase="'data'">
          <p *ngIf="item.name">
            Load a data item with ID stored in "{{ item.name }}" parameter with
            view mode "{{ item.toload_mode }}".
          </p>
          <p *ngIf="!item.name">
            Load a data item with ID {{ item.toload_id }}" parameter with view
            mode "{{ item.toload_mode }}".
          </p>
        </div>
        <div *ngSwitchCase="'list'">
          <div>
            <h2 *ngIf="item.heading">{{ item.heading }}</h2>
            <p>This list will load children of the types:</p>
            <ul>
              <li *ngFor="let type of item.list_view">{{ type.name }}</li>
            </ul>

            <p>in the '{{ item.list_mode || 'list' }}' mode</p>
          </div>
        </div>
        <div *ngSwitchCase="'data_link'">
          <div>
            <p>
              This list will load linked {{ item.toload_type }} items in the '{{
                item.toload_mode
              }}' mode.
            </p>
          </div>
        </div>
        <div *ngSwitchCase="'data_link_label'">
          <div>
            <p>
              This label will load linked {{ item.toload_type }} items in the
              '{{ item.toload_mode }}' mode.
            </p>
          </div>
        </div>
        <div *ngSwitchCase="'data_link_count'">
          <div>
            <p>
              This item will display the number of linked
              {{ item.toload_type }} items.
            </p>
          </div>
        </div>
        <div *ngSwitchCase="'hidden_default'">
          <p>Default: Set {{ item.name }} to {{ item.default }}</p>
        </div>
        <div *ngSwitchCase="'general_card'">
          <div [ngClass]="item.background">
            <div
              class="scaffold-add-buttons scaffold-before-buttons"
              (mouseover)="last_hovered = true"
              (mouseout)="last_hovered = false"
              [ngClass]="{ 'button-menu-hovered': last_hovered }">
              <hr class="line-highlight" />
              <div class="add-new-menu">
                <div class="btw-button-holder">
                  <button
                    pButton
                    [rounded]="true"
                    size="small"
                    (click)="openRootDialog($event, item.content)"
                    [pTooltip]="'add_component' | translation"
                    status="primary"
                    aria-label="Add Component"
                    class="scaffold-list-insert add-new-item"
                    *ngIf="!movingItem.selectedItem">
                    <span><i pack="fas" icon="plus"></i></span>
                  </button>
                </div>
              </div>
              <div class="btw-button-holder">
                <button
                  pButton
                  severity="info"
                  [pTooltip]="'add_component' | translation"
                  class="scaffold-list-insert"
                  (click)="moveItem(null, item.content)"
                  *ngIf="movingItem.selectedItem">
                  Insert
                </button>
              </div>
            </div>
            <div class="add-placeholder">
              <div class="color-bar"></div>
            </div>
            <app-items
              [info]="info"
              [toCreateItems]="toCreateItems"
              (deleteItem)="deleteHandler($event, item.content)"
              (addItem)="addHandler($event, it, item.content)"
              *ngFor="let it of item.content"
              [item]="it"
              [arr]="item.content"
              [undoService]="undoService"
              [parents]="parents.concat([item])"
              (itemChanged)="subChange($event)"></app-items>

            <div class="clearfix"></div>
          </div>
        </div>
        <div *ngSwitchCase="'connection'">
          <div *ngFor="let key of item.allowed_types">
            {{ key.name }}
          </div>
        </div>
        <div *ngSwitchCase="'settings_panel'">
          <div class="scaffold-sidebar-overlay" style="height: auto">
            <div style="display: flex">
              <div style="flex: 1">
                <div class="scaffold-editor-panel-heading">
                  {{ view?.panel_title || 'Settings' }}
                </div>
              </div>
              <div>
                <p-button
                  severity="info"
                  variant="text"
                  (click)="close()"
                  aria-label="Close properties panel"
                  ><i class="fas fa-times"></i
                ></p-button>
              </div>
            </div>
            <hr />
            <div
              class="scaffold-add-buttons scaffold-before-buttons"
              (mouseover)="last_hovered = true"
              (mouseout)="last_hovered = false"
              [ngClass]="{ 'button-menu-hovered': last_hovered }">
              <hr class="line-highlight" />
              <div class="add-new-menu">
                <div class="btw-button-holder">
                  <button
                    pButton
                    [rounded]="true"
                    size="small"
                    (click)="openRootDialog($event, item.content)"
                    [pTooltip]="'add_component' | translation"
                    status="primary"
                    aria-label="Add Component"
                    class="scaffold-list-insert add-new-item"
                    *ngIf="!movingItem.selectedItem">
                    <span><i class="fas fa-plus"></i></span>
                  </button>
                </div>
              </div>
              <div class="btw-button-holder">
                <button
                  pButton
                  severity="info"
                  [pTooltip]="'add_component' | translation"
                  class="scaffold-list-insert"
                  (click)="moveItem(null, item.content)"
                  *ngIf="movingItem.selectedItem">
                  Insert
                </button>
              </div>
            </div>
            <div class="add-placeholder">
              <div class="color-bar"></div>
            </div>
            <app-items
              [info]="info"
              [toCreateItems]="toCreateItems"
              (moveItemUp)="moveUpHandler($event, item.content)"
              (moveItemDown)="moveDownHandler($event, item.content)"
              (deleteItem)="deleteHandler($event, item.content)"
              (addItem)="addHandler($event, it, item.content)"
              *ngFor="let it of item.content"
              [undoService]="undoService"
              [item]="it"
              [arr]="item.content"
              [parents]="parents.concat([item])"
              (itemChanged)="subChange($event)"></app-items>
          </div>
        </div>
        <div *ngSwitchCase="'feature_restriction'">
          <div>
            <p>
              Provides a feature restriction input form for the user to select a
              feature to restrict access to.
            </p>
          </div>
        </div>
        <div *ngSwitchCase="'conditional'">
          <div>
            When {{ item.name }} is {{ item.condition }}
            <span *ngIf="item.req_value">"{{ item.req_value }}"</span>
            <div
              class="scaffold-add-buttons scaffold-before-buttons"
              (mouseover)="last_hovered = true"
              (mouseout)="last_hovered = false"
              [ngClass]="{ 'button-menu-hovered': last_hovered }">
              <hr class="line-highlight" />
              <div class="add-new-menu">
                <div class="btw-button-holder">
                  <button
                    pButton
                    [rounded]="true"
                    size="small"
                    (click)="openRootDialog($event, item.content)"
                    [pTooltip]="'add_component' | translation"
                    status="primary"
                    aria-label="Add Component"
                    class="scaffold-list-insert add-new-item"
                    *ngIf="!movingItem.selectedItem">
                    <span><i class="fas fa-plus"></i></span>
                  </button>
                </div>
              </div>
              <div class="btw-button-holder">
                <button
                  pButton
                  severity="info"
                  [pTooltip]="'add_component' | translation"
                  class="scaffold-list-insert"
                  (click)="moveItem(null, item.content)"
                  *ngIf="movingItem.selectedItem">
                  Insert
                </button>
              </div>
            </div>

            <div class="add-placeholder">
              <div class="color-bar"></div>
            </div>

            <app-items
              [info]="info"
              [toCreateItems]="toCreateItems"
              (moveItemUp)="moveUpHandler($event, item.content)"
              (moveItemDown)="moveDownHandler($event, item.content)"
              (deleteItem)="deleteHandler($event, item.content)"
              (addItem)="addHandler($event, it, item.content)"
              *ngFor="let it of item.content"
              [undoService]="undoService"
              [item]="it"
              [arr]="item.content"
              [parents]="parents.concat([item])"
              (itemChanged)="subChange($event)"></app-items>
          </div>
        </div>
        <div *ngSwitchCase="'role_conditional'">
          <div>
            <p>
              When users role is <span *ngIf="item.denied">not </span>
              <span *ngFor="let role of item.roles; let last = last"
                >{{ role.role }}<span *ngIf="!last"> or </span></span
              >
            </p>
            <div
              class="scaffold-add-buttons scaffold-before-buttons"
              (mouseover)="last_hovered = true"
              (mouseout)="last_hovered = false"
              [ngClass]="{ 'button-menu-hovered': last_hovered }">
              <hr class="line-highlight" />
              <div class="add-new-menu">
                <div class="btw-button-holder">
                  <button
                    pButton
                    [rounded]="true"
                    size="small"
                    (click)="openRootDialog($event, item.content)"
                    [pTooltip]="'add_component' | translation"
                    status="primary"
                    aria-label="Add Component"
                    class="scaffold-list-insert add-new-item"
                    *ngIf="!movingItem.selectedItem">
                    <span><i class="fas fa-plus"></i></span>
                  </button>
                </div>
              </div>
              <div class="btw-button-holder">
                <button
                  pButton
                  severity="info"
                  [pTooltip]="'add_component' | translation"
                  class="scaffold-list-insert"
                  (click)="moveItem(null, item.content)"
                  *ngIf="movingItem.selectedItem">
                  Insert
                </button>
              </div>
            </div>
            <div class="add-placeholder">
              <div class="color-bar"></div>
            </div>

            <app-items
              [info]="info"
              [toCreateItems]="toCreateItems"
              (moveItemUp)="moveUpHandler($event, item.content)"
              (moveItemDown)="moveDownHandler($event, item.content)"
              (deleteItem)="deleteHandler($event, item.content)"
              (addItem)="addHandler($event, it, item.content)"
              *ngFor="let it of item.content"
              [undoService]="undoService"
              [item]="it"
              [arr]="item.content"
              [parents]="parents.concat([item])"
              (itemChanged)="subChange($event)"></app-items>
          </div>
        </div>
        <div *ngSwitchCase="'feature_conditional'">
          <div>
            <p>
              When instance <span *ngIf="item.denied">does not have</span>
              <span *ngIf="!item.denied">has</span> the feature
              <span *ngFor="let feature of item.features; let last = last"
                >{{ feature.feature }}<span *ngIf="!last"> or </span></span
              >
            </p>
            <div
              class="scaffold-add-buttons scaffold-before-buttons"
              (mouseover)="last_hovered = true"
              (mouseout)="last_hovered = false"
              [ngClass]="{ 'button-menu-hovered': last_hovered }">
              <hr class="line-highlight" />
              <div class="add-new-menu">
                <div class="btw-button-holder">
                  <button
                    pButton
                    [rounded]="true"
                    size="small"
                    (click)="openRootDialog($event, item.content)"
                    [pTooltip]="'add_component' | translation"
                    status="primary"
                    aria-label="Add Component"
                    class="scaffold-list-insert add-new-item"
                    *ngIf="!movingItem.selectedItem">
                    <span><i class="fas fa-plus"></i></span>
                  </button>
                </div>
              </div>
              <div class="btw-button-holder">
                <button
                  pButton
                  severity="info"
                  [pTooltip]="'add_component' | translation"
                  class="scaffold-list-insert"
                  (click)="moveItem(null, item.content)"
                  *ngIf="movingItem.selectedItem">
                  Insert
                </button>
              </div>
            </div>
            <div class="add-placeholder">
              <div class="color-bar"></div>
            </div>

            <app-items
              [info]="info"
              [toCreateItems]="toCreateItems"
              (moveItemUp)="moveUpHandler($event, item.content)"
              (moveItemDown)="moveDownHandler($event, item.content)"
              (deleteItem)="deleteHandler($event, item.content)"
              (addItem)="addHandler($event, it, item.content)"
              *ngFor="let it of item.content"
              [undoService]="undoService"
              [item]="it"
              [arr]="item.content"
              [parents]="parents.concat([item])"
              (itemChanged)="subChange($event)"></app-items>
          </div>
        </div>
        <div *ngSwitchCase="'permission_conditional'">
          <div>
            <p>
              When users has the permission
              <span *ngIf="item.denied">not </span>
              <span *ngFor="let permission of item.permissions; let last = last"
                >{{ permission.permission
                }}<span *ngIf="!last"> or </span></span
              >
            </p>
            <div
              class="scaffold-add-buttons scaffold-before-buttons"
              (mouseover)="last_hovered = true"
              (mouseout)="last_hovered = false"
              [ngClass]="{ 'button-menu-hovered': last_hovered }">
              <hr class="line-highlight" />
              <div class="add-new-menu">
                <div class="btw-button-holder">
                  <button
                    pButton
                    [rounded]="true"
                    size="small"
                    (click)="openRootDialog($event, item.content)"
                    [pTooltip]="'add_component' | translation"
                    status="primary"
                    aria-label="Add Component"
                    class="scaffold-list-insert add-new-item"
                    *ngIf="!movingItem.selectedItem">
                    <span><i class="fas fa-plus"></i></span>
                  </button>
                </div>
              </div>
              <div class="btw-button-holder">
                <button
                  pButton
                  severity="info"
                  [pTooltip]="'add_component' | translation"
                  class="scaffold-list-insert"
                  (click)="moveItem(null, item.content)"
                  *ngIf="movingItem.selectedItem">
                  Insert
                </button>
              </div>
            </div>

            <div class="add-placeholder">
              <div class="color-bar"></div>
            </div>

            <app-items
              [info]="info"
              [toCreateItems]="toCreateItems"
              (moveItemUp)="moveUpHandler($event, item.content)"
              (moveItemDown)="moveDownHandler($event, item.content)"
              (deleteItem)="deleteHandler($event, item.content)"
              (addItem)="addHandler($event, it, item.content)"
              *ngFor="let it of item.content"
              [undoService]="undoService"
              [item]="it"
              [arr]="item.content"
              [parents]="parents.concat([item])"
              (itemChanged)="subChange($event)"></app-items>
          </div>
        </div>
        <div *ngSwitchCase="'create'" class="scaffold-create-button">
          <button
            pButton
            size="small"
            [rounded]="true"
            class="use-icon-button"
            *ngIf="item.button_type == 'circle'"
            [title]="item.heading || 'Create'">
            <span>
              <span
                *ngIf="item.use_icon"
                class="create-button-icon"
                style="font-size: 2rem">
                <i [ngClass]="item.icon"></i>
              </span>
              <span class="create-button-heading">{{ item.heading }}</span>
            </span>
          </button>
          <button
            pButton
            appearance="ghost"
            severity="info"
            *ngIf="item.button_type == 'ghost'"
            [title]="item.heading || 'Create'">
            <span *ngIf="item.use_icon" class="create-button-icon">
              <i [ngClass]="item.icon"></i>
            </span>
            <span class="create-button-heading">{{ item.heading }}</span>
          </button>
          <button
            pButton
            class="use-icon-button"
            *ngIf="item.button_type != 'circle' && item.button_type != 'ghost'"
            [title]="item.heading || 'Create'">
            <span *ngIf="item.use_icon" class="create-button-icon">
              <i [ngClass]="item.icon"></i>
            </span>
            <span class="create-button-heading">{{ item.heading }}</span>
          </button>
        </div>
        <div *ngSwitchCase="'accordion'" (click)="stopBubble($event)">
          <p-accordion>
            <p-accordion-panel
              *ngFor="let tab of item.tabs; index as i"
              [value]="i">
              <p-accordion-header>
                <div [innerHTML]="tab.heading | safeHtml"></div>
              </p-accordion-header>
              <p-accordion-content>
                <div
                  class="scaffold-add-buttons scaffold-before-buttons"
                  (mouseover)="last_hovered = true"
                  (mouseout)="last_hovered = false"
                  [ngClass]="{ 'button-menu-hovered': last_hovered }">
                  <hr class="line-highlight" />
                  <div class="add-new-menu">
                    <div class="btw-button-holder">
                      <button
                        pButton
                        [rounded]="true"
                        size="small"
                        (click)="openRootDialog($event, tab.content)"
                        [pTooltip]="'add_component' | translation"
                        status="primary"
                        aria-label="Add Component"
                        class="scaffold-list-insert add-new-item"
                        *ngIf="!movingItem.selectedItem">
                        <span><i class="fas fa-plus"></i></span>
                      </button>
                    </div>
                  </div>
                  <div class="btw-button-holder">
                    <button
                      pButton
                      severity="info"
                      [pTooltip]="'add_component' | translation"
                      class="scaffold-list-insert"
                      (click)="moveItem(null, tab.content)"
                      *ngIf="movingItem.selectedItem">
                      Insert
                    </button>
                  </div>
                </div>
                <div class="add-placeholder">
                  <div class="color-bar"></div>
                </div>
                <app-items
                  [info]="info"
                  [toCreateItems]="toCreateItems"
                  (deleteItem)="deleteHandler($event, tab.content)"
                  (addItem)="addHandler($event, it, tab.content)"
                  *ngFor="let it of tab.content"
                  [item]="it"
                  [arr]="tab.content"
                  [parents]="parents.concat([item])"
                  [undoService]="undoService"
                  (itemChanged)="subChange($event)"></app-items>
              </p-accordion-content>
            </p-accordion-panel>
          </p-accordion>
        </div>
        <div *ngSwitchCase="'tabs'" (click)="stopBubble($event)">
          <p-tabs value="tab-0">
            <p-tablist>
              <p-tab
                *ngFor="let tab of item.tabs; let i = index"
                [value]="'tab-' + i"
                >{{ tab.heading }}</p-tab
              >
            </p-tablist>
            <p-tabpanels>
              <p-tabpanel
                *ngFor="let tab of item.tabs; let i = index"
                [value]="'tab-' + i">
                <div
                  class="scaffold-add-buttons scaffold-before-buttons"
                  (mouseover)="last_hovered = true"
                  (mouseout)="last_hovered = false"
                  [ngClass]="{ 'button-menu-hovered': last_hovered }">
                  <hr class="line-highlight" />
                  <div class="add-new-menu">
                    <div class="btw-button-holder">
                      <button
                        pButton
                        [rounded]="true"
                        size="small"
                        (click)="openRootDialog($event, tab.content)"
                        [pTooltip]="'add_component' | translation"
                        status="primary"
                        aria-label="Add Component"
                        class="scaffold-list-insert add-new-item"
                        *ngIf="!movingItem.selectedItem">
                        <span><i class="fas fa-plus"></i></span>
                      </button>
                    </div>
                  </div>
                  <div class="btw-button-holder">
                    <button
                      pButton
                      severity="info"
                      [pTooltip]="'add_component' | translation"
                      class="scaffold-list-insert"
                      (click)="moveItem(null, tab.content)"
                      *ngIf="movingItem.selectedItem">
                      Insert
                    </button>
                  </div>
                </div>
                <div class="add-placeholder">
                  <div class="color-bar"></div>
                </div>
                <div>
                  <app-items
                    [info]="info"
                    [toCreateItems]="toCreateItems"
                    (deleteItem)="deleteHandler($event, tab.content)"
                    (addItem)="addHandler($event, it, tab.content)"
                    *ngFor="let it of tab.content"
                    [item]="it"
                    [arr]="tab.content"
                    [parents]="parents.concat([item])"
                    [undoService]="undoService"
                    (itemChanged)="subChange($event)"></app-items>
                </div>
              </p-tabpanel>
            </p-tabpanels>
          </p-tabs>
        </div>
        <div *ngSwitchCase="'youtube'" [ngClass]="item.size">
          <div class="embed-responsive embed-responsive-16by9">
            <iframe
              class="embed-responsive-item"
              [src]="
                'https://www.youtube.com/embed/' + item.video + '?rel=0' | safe
              "
              allowfullscreen></iframe>
          </div>
        </div>
        <div *ngSwitchCase="'iframe'" [ngClass]="item.size">
          <p>iFrame with URL: {{ item.url }}</p>
        </div>
        <div *ngSwitchCase="'courseimage'">
          <div
            [style.height]="
              item.height && item.height > 0 ? item.height + 'px' : 'unset'
            "
            [style.width]="
              item.width && item.width > 0 ? item.width + 'px' : 'unset'
            "
            class="sc-image-holder align-center"
            [ngClass]="{ 'sc-image-scale': item.height || item.width }">
            <img
              *ngIf="
                (item.value && item.value.length > 0) ||
                (item.url && item.url.length > 0)
              "
              [alt]="item.text"
              [src]="item.value || item.url | safe"
              [ngClass]="{ 'sc-image-landscape': item.landscape }" />
            <img
              [alt]="item.text"
              *ngIf="
                (!item.value || item.value.length) == 0 &&
                (!item.url || item.url.length == 0)
              "
              src="https://s3.us-east-2.amazonaws.com/k16-hosted-lib/default.jpg"
              [ngClass]="{ 'sc-image-landscape': item.landscape }" />
          </div>
        </div>
        <div *ngSwitchCase="'image'">
          <div class="align-center scaffold-image-holder">
            <img
              [style.height]="
                item.height && item.height > 0 ? item.height + 'px' : 'unset'
              "
              [style.width]="
                item.width && item.width > 0 ? item.width + 'px' : 'unset'
              "
              *ngIf="item.file || (item.url && item.url.length > 0)"
              [alt]="item.text"
              [src]="(item.file ? '/files/' + item.file : item.url) | safe" />
            <img
              alt="Default image"
              *ngIf="!item.file && (!item.url || item.url.length == 0)"
              src="https://s3.us-east-2.amazonaws.com/k16-hosted-lib/default.jpg"
              [style.height]="
                item.height && item.height > 0 ? item.height + 'px' : 'unset'
              " />
          </div>
        </div>
        <div *ngSwitchCase="'container'">
          <div class="container-element">
            <h3>Container {{ item.id }}</h3>
            <div
              class="scaffold-add-buttons scaffold-before-buttons"
              (mouseover)="last_hovered = true"
              (mouseout)="last_hovered = false"
              [ngClass]="{ 'button-menu-hovered': last_hovered }">
              <hr class="line-highlight" />
              <div class="add-new-menu">
                <div class="btw-button-holder">
                  <button
                    pButton
                    [rounded]="true"
                    size="small"
                    (click)="openRootDialog($event, item.content)"
                    [pTooltip]="'add_component' | translation"
                    status="primary"
                    aria-label="Add Component"
                    class="scaffold-list-insert add-new-item"
                    *ngIf="!movingItem.selectedItem">
                    <span><i class="fas fa-plus"></i></span>
                  </button>
                </div>
              </div>
              <div class="btw-button-holder">
                <button
                  pButton
                  severity="info"
                  [pTooltip]="'add_component' | translation"
                  class="scaffold-list-insert"
                  (click)="moveItem(null, item.content)"
                  *ngIf="movingItem.selectedItem">
                  Insert
                </button>
              </div>
            </div>
            <div class="add-placeholder">
              <div class="color-bar"></div>
            </div>
            <app-items
              [info]="info"
              [toCreateItems]="toCreateItems"
              (deleteItem)="deleteHandler($event, item.content)"
              (addItem)="addHandler($event, it, item.content)"
              *ngFor="let it of item.content"
              [item]="it"
              [arr]="item.content"
              [parents]="parents.concat([item])"
              [undoService]="undoService"
              (itemChanged)="subChange($event)"></app-items>

            <div class="clearfix"></div>
          </div>
        </div>
        <div *ngSwitchCase="'well'">
          <div [ngClass]="item.background">
            <div
              class="scaffold-add-buttons scaffold-before-buttons"
              (mouseover)="last_hovered = true"
              (mouseout)="last_hovered = false"
              [ngClass]="{ 'button-menu-hovered': last_hovered }">
              <hr class="line-highlight" />
              <div class="add-new-menu">
                <div class="btw-button-holder">
                  <button
                    pButton
                    [rounded]="true"
                    size="small"
                    (click)="openRootDialog($event, item.content)"
                    [pTooltip]="'add_component' | translation"
                    status="primary"
                    aria-label="Add Component"
                    class="scaffold-list-insert add-new-item"
                    *ngIf="!movingItem.selectedItem">
                    <span><i class="fas fa-plus"></i></span>
                  </button>
                </div>
              </div>
              <div class="btw-button-holder">
                <button
                  pButton
                  severity="info"
                  [pTooltip]="'add_component' | translation"
                  class="scaffold-list-insert"
                  (click)="moveItem(null, item.content)"
                  *ngIf="movingItem.selectedItem">
                  Insert
                </button>
              </div>
            </div>
            <div class="add-placeholder">
              <div class="color-bar"></div>
            </div>
            <app-items
              [info]="info"
              [toCreateItems]="toCreateItems"
              (deleteItem)="deleteHandler($event, item.content)"
              (addItem)="addHandler($event, it, item.content)"
              *ngFor="let it of item.content"
              [item]="it"
              [arr]="item.content"
              [undoService]="undoService"
              [parents]="parents.concat([item])"
              (itemChanged)="subChange($event)"></app-items>

            <div class="clearfix"></div>
          </div>
        </div>
        <div *ngSwitchCase="'block_style'">
          <div
            class="scaffold-block-styling"
            [ngClass]="classes"
            [style]="calcStyle() | safeStyle">
            <div
              class="scaffold-add-buttons scaffold-before-buttons"
              (mouseover)="last_hovered = true"
              (mouseout)="last_hovered = false"
              [ngClass]="{ 'button-menu-hovered': last_hovered }">
              <hr class="line-highlight" />
              <div class="add-new-menu">
                <div class="btw-button-holder">
                  <button
                    pButton
                    [rounded]="true"
                    size="small"
                    (click)="openRootDialog($event, item.content)"
                    [pTooltip]="'add_component' | translation"
                    status="primary"
                    aria-label="Add Component"
                    class="scaffold-list-insert add-new-item"
                    *ngIf="!movingItem.selectedItem">
                    <span><i class="fas fa-plus"></i></span>
                  </button>
                </div>
              </div>
              <div class="btw-button-holder">
                <button
                  pButton
                  severity="info"
                  [pTooltip]="'add_component' | translation"
                  class="scaffold-list-insert"
                  (click)="moveItem(null, item.content)"
                  *ngIf="movingItem.selectedItem">
                  Insert
                </button>
              </div>
            </div>
            <div class="add-placeholder">
              <div class="color-bar"></div>
            </div>
            <app-items
              [info]="info"
              [toCreateItems]="toCreateItems"
              (deleteItem)="deleteHandler($event, item.content)"
              (addItem)="addHandler($event, it, item.content)"
              *ngFor="let it of item.content"
              [item]="it"
              [arr]="item.content"
              [undoService]="undoService"
              [parents]="parents.concat([item])"
              (itemChanged)="subChange($event)"></app-items>

            <div class="clearfix"></div>
          </div>
        </div>
        <div *ngSwitchCase="'padding'">
          <div
            [style]="
              'padding:' +
                (item.top_bottom || 0) +
                'px ' +
                (item.left_right || 0) +
                'px' | safeStyle
            ">
            <span
              >Padding Top/Bottom: {{ item.top_bottom || 0 }}px, Padding
              Left/Right: {{ item.left_right || 0 }}px</span
            >
            <div
              class="scaffold-add-buttons scaffold-before-buttons"
              (mouseover)="last_hovered = true"
              (mouseout)="last_hovered = false"
              [ngClass]="{ 'button-menu-hovered': last_hovered }">
              <hr class="line-highlight" />
              <div class="add-new-menu">
                <div class="btw-button-holder">
                  <button
                    pButton
                    [rounded]="true"
                    size="small"
                    (click)="openRootDialog($event, item.content)"
                    [pTooltip]="'add_component' | translation"
                    status="primary"
                    aria-label="Add Component"
                    class="scaffold-list-insert add-new-item"
                    *ngIf="!movingItem.selectedItem">
                    <span><i class="fas fa-plus"></i></span>
                  </button>
                </div>
              </div>
              <div class="btw-button-holder">
                <button
                  pButton
                  severity="info"
                  [pTooltip]="'add_component' | translation"
                  class="scaffold-list-insert"
                  (click)="moveItem(null, item.content)"
                  *ngIf="movingItem.selectedItem">
                  Insert
                </button>
              </div>
            </div>
            <div class="add-placeholder">
              <div class="color-bar"></div>
            </div>
            <app-items
              [info]="info"
              [toCreateItems]="toCreateItems"
              (deleteItem)="deleteHandler($event, item.content)"
              (addItem)="addHandler($event, it, item.content)"
              *ngFor="let it of item.content"
              [item]="it"
              [arr]="item.content"
              [undoService]="undoService"
              [parents]="parents.concat([item])"
              (itemChanged)="subChange($event)"></app-items>

            <div class="clearfix"></div>
          </div>
        </div>

        <div *ngSwitchCase="'outcomesedit'">Editor for outcomes</div>
        <div *ngSwitchCase="'outcomes'">
          <p>{{ item.intro }}</p>
          <ol>
            <li>Outcome 1</li>
            <li>Outcome 2</li>
          </ol>
        </div>
        <div *ngSwitchCase="'row'">
          <div
            class="row"
            [ngClass]="{
              'align-items-start': item.vertical_align == 'top',
              'align-items-center': item.vertical_align == 'middle',
              'align-items-end': item.vertical_align == 'bottom',
            }">
            <div
              *ngFor="let list of item.content; let $index = index"
              class="col-md-{{ item.widths[$index] }}">
              <div
                class="scaffold-add-buttons scaffold-before-buttons"
                (mouseover)="columnData($index).last_hovered = true"
                (mouseout)="columnData($index).last_hovered = false"
                [ngClass]="{
                  'button-menu-hovered': columnData($index).last_hovered,
                }">
                <hr class="line-highlight" />
                <div class="add-new-menu">
                  <div class="btw-button-holder">
                    <button
                      pButton
                      [rounded]="true"
                      size="small"
                      (click)="openRootDialog($event, list)"
                      [pTooltip]="'add_component' | translation"
                      status="primary"
                      aria-label="Add Component"
                      class="scaffold-list-insert add-new-item"
                      *ngIf="!movingItem.selectedItem">
                      <span><i class="fas fa-plus"></i></span>
                    </button>
                  </div>
                </div>
                <div class="btw-button-holder">
                  <button
                    pButton
                    severity="info"
                    [pTooltip]="'add_component' | translation"
                    class="scaffold-list-insert"
                    (click)="moveItem(null, list)"
                    *ngIf="movingItem.selectedItem">
                    Insert
                  </button>
                </div>
              </div>
              <div class="add-placeholder">
                <div class="color-bar"></div>
              </div>
              <app-items
                [info]="info"
                [toCreateItems]="toCreateItems"
                (deleteItem)="deleteHandler($event, list)"
                (addItem)="addHandler($event, it, list)"
                *ngFor="let it of list"
                [item]="it"
                [data]="item.data"
                [arr]="list"
                [parents]="parents.concat([item])"
                [undoService]="undoService"
                (itemChanged)="subChange($event)"></app-items>
            </div>
          </div>
        </div>
        <div *ngSwitchCase="'flex'">
          <div class="flex-row">
            <div
              *ngFor="let list of item.content; let $index = index"
              [ngClass]="list.is_hidden ? 'flex-column-0' : list.flex_width">
              <button
                *ngIf="list.collapsible"
                pButton
                (click)="list.is_hidden = !list.is_hidden">
                <i
                  [ngClass]="list.icon"
                  [title]="list.title"
                  [style.color]="list.color"></i>
              </button>
              <div
                class="scaffold-add-buttons scaffold-before-buttons"
                (mouseover)="columnData($index).last_hovered = true"
                (mouseout)="columnData($index).last_hovered = false"
                [ngClass]="{
                  'button-menu-hovered': columnData($index).last_hovered,
                }">
                <hr class="line-highlight" />
                <div class="add-new-menu">
                  <div class="btw-button-holder">
                    <button
                      pButton
                      [rounded]="true"
                      size="small"
                      (click)="openRootDialog($event, list.content)"
                      [pTooltip]="'add_component' | translation"
                      status="primary"
                      aria-label="Add Component"
                      class="scaffold-list-insert add-new-item"
                      *ngIf="!movingItem.selectedItem">
                      <span><i class="fas fa-plus"></i></span>
                    </button>
                  </div>
                </div>
                <div class="btw-button-holder">
                  <button
                    pButton
                    severity="info"
                    [pTooltip]="'add_component' | translation"
                    class="scaffold-list-insert"
                    (click)="moveItem(null, list.content)"
                    *ngIf="movingItem.selectedItem">
                    Insert
                  </button>
                </div>
              </div>

              <div class="add-placeholder">
                <div class="color-bar"></div>
              </div>
              <div *ngIf="!list.is_hidden">
                <app-items
                  [info]="info"
                  [toCreateItems]="toCreateItems"
                  (deleteItem)="deleteHandler($event, list.content)"
                  (addItem)="addHandler($event, it, list.content)"
                  *ngFor="let it of list.content"
                  [item]="it"
                  [data]="item.data"
                  [arr]="list.content"
                  [parents]="parents.concat([item])"
                  [undoService]="undoService"
                  (itemChanged)="subChange($event)"></app-items>
              </div>
            </div>
          </div>
        </div>
        <!--Forms and inputs-->
        <div *ngSwitchCase="'button'">
          <button pButton>{{ item.text }}</button>
        </div>
        <div *ngSwitchCase="'input'">
          <div *ngIf="item?.input_type === 'textarea'">
            Rich text input block
          </div>
          <div *ngIf="item?.input_type !== 'textarea'">
            <div class="form-field">
              <input
                pInputText
                placeholder="{{ item.label }}"
                type="{{ item?.input_type }}" />
            </div>
          </div>
        </div>
        <div *ngSwitchCase="'switch'">
          <scaffold-toggle-slide status="info" [position]="item.position">{{
            item.label
          }}</scaffold-toggle-slide>
        </div>
        <div *ngSwitchCase="'check'">
          <p-checkbox binary="true" [inputId]="item.label"></p-checkbox>
          <label for="item.label">{{ item.label }}</label>
        </div>
        <div *ngSwitchCase="'radio'">
          <div
            [ngClass]="{ 'radio-horizontal': item.direction === 'horizontal' }">
            <div *ngFor="let option of item.options; let i = index">
              <p-radioButton
                variant="filled"
                [inputId]="'input_id_' + i"
                name="conditions"
                [value]="option.value"
                [(ngModel)]="demoValue"></p-radioButton>
              <label [for]="'input_id_' + i">{{ option.label }}</label>
            </div>
          </div>
        </div>
        <div *ngSwitchCase="'select'">
          <!-- previously wasnt setting anything with nebular select but will mimic that... -->
          <p-select
            ngDefaultControl
            [placeholder]="item.label"
            [options]="item.options"
            optionLabel="label"
            optionValue="value" />
        </div>
        <div *ngSwitchCase="'date'">
          <app-time-picker
            [item]="item"
            (changed)="dateChange(data, item.name, $event)"></app-time-picker>
        </div>
        <div *ngSwitchCase="'phone_number'">
          <app-phone-number></app-phone-number>
        </div>
        <div *ngSwitchCase="'form'">
          <form
            sc-method="item.method"
            sc-form="item.action"
            sc-form-reset="item.reset">
            <div
              class="scaffold-add-buttons scaffold-before-buttons"
              (mouseover)="last_hovered = true"
              (mouseout)="last_hovered = false"
              [ngClass]="{ 'button-menu-hovered': last_hovered }">
              <hr class="line-highlight" />
              <div class="add-new-menu">
                <div class="btw-button-holder">
                  <button
                    pButton
                    [rounded]="true"
                    size="small"
                    (click)="openRootDialog($event, item.content)"
                    [pTooltip]="'add_component' | translation"
                    status="primary"
                    aria-label="Add Component"
                    class="scaffold-list-insert add-new-item"
                    *ngIf="!movingItem.selectedItem">
                    <span><i class="fas fa-plus"></i></span>
                  </button>
                </div>
              </div>
              <div class="btw-button-holder">
                <button
                  pButton
                  severity="info"
                  [pTooltip]="'add_component' | translation"
                  class="scaffold-list-insert"
                  (click)="moveItem(null, item.content)"
                  *ngIf="movingItem.selectedItem">
                  Insert
                </button>
              </div>
            </div>

            <div class="add-placeholder">
              <div class="color-bar"></div>
            </div>
            <app-items
              [info]="info"
              [toCreateItems]="toCreateItems"
              (deleteItem)="deleteHandler($event, item.content)"
              (addItem)="addHandler($event, it, item.content)"
              *ngFor="let it of item.content"
              [item]="it"
              [data]="item.data"
              [arr]="item.content"
              [parents]="parents.concat([item])"
              [undoService]="undoService"
              (itemChanged)="subChange($event)"></app-items>

            <button pButton ng-show="item.submit">{{ item.submit }}</button>
          </form>
        </div>

        <div
          *ngSwitchCase="'wizard'"
          (click)="stopBubble($event)"
          class="scaffold-wizard-holder"
          [ngClass]="{ 'tab-style-wizard': item.use_tab_style }">
          <h2>{{ item.title }}</h2>
          <p-stepper
            *ngIf="item.direction !== 'vertical'"
            #stepper
            [linear]="false"
            [value]="selectedStep">
            <p-step-list>
              <p-step
                *ngFor="let step of item.tabs; let $index = index"
                [value]="$index"
                >{{ step.heading }}</p-step
              >
            </p-step-list>
            <p-step-panels>
              <p-step-panel
                *ngFor="let step of item.tabs; let $index = index"
                [value]="$index">
                <ng-template #content let-activateCallback="activateCallback">
                  <div
                    class="scaffold-add-buttons scaffold-before-buttons"
                    (mouseover)="last_hovered = true"
                    (mouseout)="last_hovered = false"
                    [ngClass]="{ 'button-menu-hovered': last_hovered }">
                    <hr class="line-highlight" />
                    <div class="add-new-menu">
                      <div class="btw-button-holder">
                        <button
                          pButton
                          [rounded]="true"
                          severity="primary"
                          size="small"
                          (click)="openRootDialog($event, step.content)"
                          [pTooltip]="'add_component' | translation"
                          aria-label="Add Component"
                          class="scaffold-list-insert add-new-item"
                          *ngIf="!movingItem.selectedItem">
                          <span><i class="fas fa-plus"></i></span>
                        </button>
                      </div>
                    </div>
                    <div class="btw-button-holder">
                      <button
                        pButton
                        severity="info"
                        [pTooltip]="'add_component' | translation"
                        class="scaffold-list-insert"
                        (click)="moveItem(null, step.content)"
                        *ngIf="movingItem.selectedItem">
                        Insert
                      </button>
                    </div>
                  </div>

                  <div class="add-placeholder">
                    <div class="color-bar"></div>
                  </div>
                  <div>
                    <app-items
                      [info]="info"
                      [toCreateItems]="toCreateItems"
                      (deleteItem)="deleteHandler($event, step.content)"
                      (addItem)="addHandler($event, it, step.content)"
                      *ngFor="let it of step.content"
                      [item]="it"
                      [data]="item.data"
                      [arr]="step.content"
                      [parents]="parents.concat([item])"
                      [undoService]="undoService"
                      (itemChanged)="subChange($event)"></app-items>
                  </div>
                  <div>
                    <button
                      pButton
                      (click)="activateCallback($index - 1)"
                      [disabled]="$index === 0">
                      Prev<span *ngIf="$index > 0"
                        >: {{ item.tabs[$index - 1].heading }}</span
                      >
                    </button>
                    <button
                      pButton
                      (click)="activateCallback($index + 1)"
                      [disabled]="$index >= item.tabs.length - 1">
                      Next<span *ngIf="$index < item.tabs.length - 1"
                        >: {{ item.tabs[$index + 1].heading }}</span
                      >
                    </button>
                  </div>
                </ng-template>
              </p-step-panel>
            </p-step-panels>
          </p-stepper>
          <p-stepper
            *ngIf="item.direction === 'vertical'"
            #stepper
            [linear]="false"
            [value]="selectedStep">
            <p-step-item
              *ngFor="let step of item.tabs; let $index = index"
              [value]="$index">
              <p-step>{{ step.heading }}</p-step>
              <p-step-panel>
                <ng-template #content let-activateCallback="activateCallback">
                  <div
                    class="scaffold-add-buttons scaffold-before-buttons"
                    (mouseover)="last_hovered = true"
                    (mouseout)="last_hovered = false"
                    [ngClass]="{ 'button-menu-hovered': last_hovered }">
                    <hr class="line-highlight" />
                    <div class="add-new-menu">
                      <div class="btw-button-holder">
                        <button
                          pButton
                          [rounded]="true"
                          severity="primary"
                          size="small"
                          (click)="openRootDialog($event, step.content)"
                          [pTooltip]="'add_component' | translation"
                          aria-label="Add Component"
                          class="scaffold-list-insert add-new-item"
                          *ngIf="!movingItem.selectedItem">
                          <span><i class="fas fa-plus"></i></span>
                        </button>
                      </div>
                    </div>
                    <div class="btw-button-holder">
                      <button
                        pButton
                        severity="info"
                        [pTooltip]="'add_component' | translation"
                        class="scaffold-list-insert"
                        (click)="moveItem(null, step.content)"
                        *ngIf="movingItem.selectedItem">
                        Insert
                      </button>
                    </div>
                  </div>

                  <div class="add-placeholder">
                    <div class="color-bar"></div>
                  </div>
                  <div>
                    <app-items
                      [info]="info"
                      [toCreateItems]="toCreateItems"
                      (deleteItem)="deleteHandler($event, step.content)"
                      (addItem)="addHandler($event, it, step.content)"
                      *ngFor="let it of step.content"
                      [item]="it"
                      [data]="item.data"
                      [arr]="step.content"
                      [parents]="parents.concat([item])"
                      [undoService]="undoService"
                      (itemChanged)="subChange($event)"></app-items>
                  </div>
                  <div>
                    <button
                      pButton
                      (click)="activateCallback($index - 1)"
                      [disabled]="$index === 0">
                      Prev<span *ngIf="$index > 0"
                        >: {{ item.tabs[$index - 1].heading }}</span
                      >
                    </button>
                    <button
                      pButton
                      (click)="activateCallback($index + 1)"
                      [disabled]="$index >= item.tabs.length - 1">
                      Next<span *ngIf="$index < item.tabs.length - 1"
                        >: {{ item.tabs[$index + 1].heading }}</span
                      >
                    </button>
                  </div>
                </ng-template>
              </p-step-panel>
            </p-step-item>
          </p-stepper>
        </div>
        <div *ngSwitchCase="'template'">
          <div class="scaffold-template" [ngSwitch]="item.display_type">
            <h1 *ngSwitchCase="'h1'" [ngClass]="item.classes">
              <span *ngFor="let ite of item.content"
                ><span *ngIf="ite.name">{{ ite.name }} </span
                ><span *ngIf="!ite.name">{{ ite.text }} </span></span
              >
            </h1>
            <h2 *ngSwitchCase="'h2'" [ngClass]="item.classes">
              <span *ngFor="let ite of item.content"
                ><span *ngIf="ite.name">{{ ite.name }} </span
                ><span *ngIf="!ite.name">{{ ite.text }} </span></span
              >
            </h2>
            <h3 *ngSwitchCase="'h3'" [ngClass]="item.classes">
              <span *ngFor="let ite of item.content"
                ><span *ngIf="ite.name">{{ ite.name }} </span
                ><span *ngIf="!ite.name">{{ ite.text }} </span></span
              >
            </h3>
            <h4 *ngSwitchCase="'h4'" [ngClass]="item.classes">
              <span *ngFor="let ite of item.content"
                ><span *ngIf="ite.name">{{ ite.name }} </span
                ><span *ngIf="!ite.name">{{ ite.text }} </span></span
              >
            </h4>
            <h5 *ngSwitchCase="'h5'" [ngClass]="item.classes">
              <span *ngFor="let ite of item.content"
                ><span *ngIf="ite.name">{{ ite.name }} </span
                ><span *ngIf="!ite.name">{{ ite.text }} </span></span
              >
            </h5>
            <h6 *ngSwitchCase="'h6'" [ngClass]="item.classes">
              <span *ngFor="let ite of item.content"
                ><span *ngIf="ite.name">{{ ite.name }} </span
                ><span *ngIf="!ite.name">{{ ite.text }} </span></span
              >
            </h6>
            <p *ngSwitchDefault [ngClass]="item.classes">
              <span *ngFor="let ite of item.content"
                ><span *ngIf="ite.name">{{ ite.name }} </span
                ><span *ngIf="!ite.name">{{ ite.text }} </span></span
              >
            </p>
          </div>
        </div>
        <div *ngSwitchCase="'integration'">Select an integration</div>
        <scaffold-file-view
          *ngSwitchCase="'attachment'"
          [item]="item"></scaffold-file-view>
        <div *ngSwitchCase="'icon'" class="icon-holder">
          <i
            [ngClass]="item.icon"
            [title]="item.title"
            [style.color]="item.color"></i>
        </div>
        <div *ngSwitchCase="'custom'">
          <app-customrendered [item]="item" [edit]="true"></app-customrendered>
        </div>
        <div *ngSwitchCase="'data_table'" class="scaffold-table-holder">
          <table style="width: 100%">
            <thead>
              <tr>
                <th style="width: 100px" *ngFor="let col of columns">Delete</th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of item.data">
                <td *ngFor="let col of columns">
                  {{ row[col.key] }}
                </td>
                <td>
                  <button
                    pButton
                    size="small"
                    [rounded]="true"
                    (click)="deleteRow(element, item.data)"
                    severity="warn"
                    [title]="'delete' | translation">
                    <i class="fat fa-trash-alt"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <button pButton *ngIf="false" (click)="addRow(item)">Add Row</button>
          <button pButton (click)="redrawColumns()">Redraw Columns</button>
        </div>
        <div *ngSwitchCase="'data_array'">
          <div
            class="scaffold-add-buttons scaffold-before-buttons"
            (mouseover)="last_hovered = true"
            (mouseout)="last_hovered = false"
            [ngClass]="{ 'button-menu-hovered': last_hovered }">
            <hr class="line-highlight" />
            <div class="add-new-menu">
              <div class="btw-button-holder">
                <button
                  pButton
                  [rounded]="true"
                  size="small"
                  (click)="openRootDialog($event, item.content)"
                  [pTooltip]="'add_component' | translation"
                  status="primary"
                  aria-label="Add Component"
                  class="scaffold-list-insert add-new-item"
                  *ngIf="!movingItem.selectedItem">
                  <span><i class="fas fa-plus"></i></span>
                </button>
              </div>
            </div>
            <div class="btw-button-holder">
              <button
                pButton
                severity="info"
                [pTooltip]="'add_component' | translation"
                class="scaffold-list-insert"
                (click)="moveItem(null, item.content)"
                *ngIf="movingItem.selectedItem">
                Insert
              </button>
            </div>
          </div>
          <div class="add-placeholder">
            <div class="color-bar"></div>
          </div>
          <div class="scaffold-create-button" [ngClass]="item.alignment">
            <button
              pButton
              size="small"
              [rounded]="true"
              class="use-icon-button"
              *ngIf="item.button_type == 'circle'">
              <span>
                <span
                  *ngIf="item.use_icon"
                  class="create-button-icon"
                  style="font-size: 2rem">
                  <i [ngClass]="item.icon"></i>
                </span>
                <span class="create-button-heading">{{
                  item.add_label || 'Add Item'
                }}</span>
              </span>
            </button>
            <button
              pButton
              appearance="ghost"
              severity="info"
              *ngIf="item.button_type == 'ghost'">
              <span *ngIf="item.use_icon" class="create-button-icon">
                <i [ngClass]="item.icon"></i>
              </span>
              <span class="create-button-heading">{{
                item.add_label || 'Add Item'
              }}</span>
            </button>
            <button
              pButton
              class="use-icon-button"
              *ngIf="
                item.button_type != 'circle' && item.button_type != 'ghost'
              ">
              <span *ngIf="item.use_icon" class="create-button-icon">
                <i [ngClass]="item.icon"></i>
              </span>
              <span class="create-button-heading">{{
                item.add_label || 'Add Item'
              }}</span>
            </button>
          </div>
          <app-items
            [info]="info"
            [toCreateItems]="toCreateItems"
            (moveItemUp)="moveUpHandler($event, item.content)"
            (moveItemDown)="moveDownHandler($event, item.content)"
            (deleteItem)="deleteHandler($event, item.content)"
            (addItem)="addHandler($event, it, item.content)"
            *ngFor="let it of item.content"
            [undoService]="undoService"
            [item]="it"
            [arr]="item.content"
            [parents]="parents.concat([item])"
            (itemChanged)="subChange($event)"></app-items>
        </div>
        <div *ngSwitchCase="'table_like_columns'">
          <table>
            <tr>
              <th
                *ngFor="let column of item.columns; let $index = index"
                class="tl-header-cell">
                {{ column.label }}
              </th>
            </tr>
            <tr class="tl-body-row">
              <td
                *ngFor="let column of item.columns; let $index = index"
                class="tl-body-cell">
                <div
                  class="scaffold-add-buttons scaffold-before-buttons"
                  (mouseover)="columnData($index).last_hovered = true"
                  (mouseout)="columnData($index).last_hovered = false"
                  [ngClass]="{
                    'button-menu-hovered': columnData($index).last_hovered,
                  }">
                  <hr class="line-highlight" />
                  <div class="add-new-menu">
                    <div class="btw-button-holder">
                      <button
                        pButton
                        [rounded]="true"
                        size="small"
                        (click)="openRootDialog($event, column.content)"
                        [pTooltip]="'add_component' | translation"
                        status="primary"
                        aria-label="Add Component"
                        class="scaffold-list-insert add-new-item"
                        *ngIf="!movingItem.selectedItem">
                        <span><i class="fas fa-plus"></i></span>
                      </button>
                    </div>
                  </div>
                  <div class="btw-button-holder">
                    <button
                      pButton
                      severity="info"
                      [pTooltip]="'add_component' | translation"
                      class="scaffold-list-insert"
                      (click)="moveItem(null, column.content)"
                      *ngIf="movingItem.selectedItem">
                      Insert
                    </button>
                  </div>
                </div>
                <div class="add-placeholder">
                  <div class="color-bar"></div>
                </div>
                <app-items
                  [info]="info"
                  [toCreateItems]="toCreateItems"
                  (deleteItem)="deleteHandler($event, column.content)"
                  (addItem)="addHandler($event, it, column.content)"
                  *ngFor="let it of column.content"
                  [item]="it"
                  [data]="item.data"
                  [arr]="list"
                  [parents]="parents.concat([item])"
                  [undoService]="undoService"
                  (itemChanged)="subChange($event)"></app-items>
              </td>
            </tr>
          </table>
        </div>
        <div *ngSwitchCase="'data_visuals'">
          <div #graph></div>
        </div>
        <div *ngSwitchCase="'scaffold_json'">
          <div>JSON data viewer</div>
        </div>
        <div *ngSwitchCase="'template_data_array'">
          <div
            class="scaffold-add-buttons scaffold-before-buttons"
            (mouseover)="last_hovered = true"
            (mouseout)="last_hovered = false"
            [ngClass]="{ 'button-menu-hovered': last_hovered }">
            <hr class="line-highlight" />
            <div class="add-new-menu">
              <div class="btw-button-holder">
                <button
                  pButton
                  [rounded]="true"
                  size="small"
                  (click)="openRootDialog($event, item.content)"
                  [pTooltip]="'add_component' | translation"
                  status="primary"
                  aria-label="Add Component"
                  class="scaffold-list-insert add-new-item"
                  *ngIf="!movingItem.selectedItem">
                  <span><i class="fas fa-plus"></i></span>
                </button>
              </div>
            </div>
            <div class="btw-button-holder">
              <button
                pButton
                severity="info"
                [pTooltip]="'add_component' | translation"
                class="scaffold-list-insert"
                (click)="moveItem(null, item.content)"
                *ngIf="movingItem.selectedItem">
                Insert
              </button>
            </div>
          </div>
          <div class="add-placeholder">
            <div class="color-bar"></div>
          </div>
          <app-items
            [info]="info"
            [toCreateItems]="toCreateItems"
            (moveItemUp)="moveUpHandler($event, item.content)"
            (moveItemDown)="moveDownHandler($event, item.content)"
            (deleteItem)="deleteHandler($event, item.content)"
            (addItem)="addHandler($event, it, item.content)"
            *ngFor="let it of item.content"
            [undoService]="undoService"
            [item]="it"
            [arr]="item.content"
            [parents]="parents.concat([item])"
            (itemChanged)="subChange($event)"></app-items>
        </div>
        <div *ngSwitchCase="'list_index'">
          <div
            class="scaffold-add-buttons scaffold-before-buttons"
            (mouseover)="last_hovered = true"
            (mouseout)="last_hovered = false"
            [ngClass]="{ 'button-menu-hovered': last_hovered }">
            <hr class="line-highlight" />
            <div class="add-new-menu">
              <div class="btw-button-holder">
                <button
                  pButton
                  [rounded]="true"
                  size="small"
                  (click)="openRootDialog($event, item.content)"
                  [pTooltip]="'add_component' | translation"
                  status="primary"
                  aria-label="Add Component"
                  class="scaffold-list-insert add-new-item"
                  *ngIf="!movingItem.selectedItem">
                  <span><i class="fas fa-plus"></i></span>
                </button>
              </div>
            </div>
            <div class="btw-button-holder">
              <button
                pButton
                severity="info"
                [pTooltip]="'add_component' | translation"
                class="scaffold-list-insert"
                (click)="moveItem(null, item.content)"
                *ngIf="movingItem.selectedItem">
                Insert
              </button>
            </div>
          </div>
          <div class="add-placeholder">
            <div class="color-bar"></div>
          </div>
          s= to
          <app-items
            [info]="info"
            [toCreateItems]="toCreateItems"
            (deleteItem)="deleteHandler($event, item.content)"
            (addItem)="addHandler($event, it, item.content)"
            *ngFor="let it of item.content"
            [item]="it"
            [arr]="item.content"
            [parents]="parents.concat([item])"
            [undoService]="undoService"
            (itemChanged)="subChange($event)"></app-items>

          <div class="clearfix"></div>
        </div>
        <div *ngSwitchDefault>
          <!-- No Template for {{settings[item.type] ? settings[item.type].Name : item.type}} -->
        </div>
      </div>
    </div>
  </div>
  <div
    class="scaffold-add-buttons"
    (mouseover)="last_hovered_after = true"
    (mouseout)="last_hovered_after = false"
    [ngClass]="{ 'button-menu-hovered': last_hovered_after }">
    <hr class="line-highlight" />
    <div class="add-new-menu">
      <div class="btw-button-holder">
        <button
          pButton
          size="small"
          (click)="openDialog($event)"
          [pTooltip]="'add_component' | translation"
          [rounded]="true"
          status="primary"
          aria-label="Add Component"
          class="scaffold-list-insert add-new-item"
          *ngIf="!movingItem.selectedItem">
          <span><i class="fas fa-plus"></i></span>
        </button>
      </div>
    </div>

    <div class="btw-button-holder">
      <button
        pButton
        severity="info"
        [pTooltip]="'add_component' | translation"
        class="scaffold-list-insert"
        (click)="moveItem(item, arr)"
        *ngIf="movingItem.selectedItem">
        Insert
      </button>
    </div>
  </div>
  <div class="add-placeholder">
    <div class="color-bar"></div>
  </div>
</div>
